// Public cloudhouse.com pages the hub links out to. The marketing site owns these paths, so
// every link goes through here and a moved page is a one-line fix.
export const CONTACT_URL = 'https://cloudhouse.com/contact-cloudhouse/';
export const PRIVACY_POLICY_URL = 'https://www.cloudhouse.com/privacy-policy';
export const COOKIE_POLICY_URL = 'https://www.cloudhouse.com/cookie-policy';
